import { request } from "@/hooks/useRequest";

export const http = {
  /**
   * 首页
   *
   * 首先调用 首页接口
   * 如果 result.is_line && result.xiao_rank.length == 0 || result.zhong_rank.length == 0
   * 请求首页-排行榜接口：
   * 如果 code == 1020, 则sleep 1秒之后再请求（重复5次后，提示错误，结束请求）
   */
  index: {
    index(config = {}) {
      return request({
        url: "/v1/index",
        methods: "get",
        ...config,
      });
    },

    rank(config = {}) {
      return request({
        url: "/v1/index_rank",
        methods: "get",
        ...config,
      });
    },
  },

  /**
   * 登录注册
   */
  login: {
    /**
     * 发送验证码
     */
    sebdSMS(config = {}) {
      return request({
        url: "/v1/passport/send_sms",
        methods: "post",
        ...config,
      });
    },

    /**
     * 登录
     */
    toLogin(config = {}) {
      return request({
        url: "/v1/passport/login",
        methods: "post",
        ...config,
      });
    },

    /**
     * 注册
     */
    toRegister(config = {}) {
      return request({
        url: "/v1/passport/register",
        methods: "post",
        ...config,
      });
    },

    /**
     * 找回密码
     */
    toRetrieve(config = {}) {
      return request({
        url: "/v1/passport/register",
        methods: "post",
        ...config,
      });
    },
  },

  /**
   * 网站设置
   */
  config: {
    /**
     * 用户协议
     */
    userAgreement(config = {}) {
      return request({
        url: "/v1/web_config/user_agreement",
        methods: "get",
        ...config,
      });
    },

    /**
     * 隐私政策
     */
    privacyPolicy(config = {}) {
      return request({
        url: "/v1/web_config/privacy_policy",
        methods: "get",
        ...config,
      });
    },
  },

  /**
   * 消息通知
   */
  notice: {
    /**
     * 消息列表
     */
    lists(config = {}) {
      return request({
        url: "/v1/notice/lists",
        methods: "get",
        ...config,
      });
    },
  },

  /**
   * 收货地址
   */
  address: {
    /**
     * 地址列表
     */
    lists(config = {}) {
      return request({
        url: "/v1/address/lists",
        methods: "get",
        ...config,
      });
    },
    /**
     * 添加收货地址
     */
    add(config = {}) {
      return request({
        url: "/v1/address/add",
        methods: "post",
        ...config,
      });
    },
    /**
     * 编辑收货地址
     */
    edit(config = {}) {
      return request({
        url: "/v1/address/edit",
        methods: "post",
        ...config,
      });
    },
    /**
     * 编辑地址时获取对应的省市区
     */
    editRegion(config = {}) {
      return request({
        url: "/v1/address/edit_region",
        methods: "get",
        ...config,
      });
    },
    /**
     * 所有省
     */
    allProvince(config = {}) {
      return request({
        url: "/v1/address/all_province",
        methods: "get",
        ...config,
      });
    },
    /**
     * 所有市
     */
    allCity(config = {}) {
      return request({
        url: "/v1/address/all_city",
        methods: "get",
        ...config,
      });
    },
    /**
     * 所有区
     */
    allArea(config = {}) {
      return request({
        url: "/v1/address/all_area",
        methods: "get",
        ...config,
      });
    },
  },

  /**
   * 购物车
   */
  shopCart: {
    /**
     * 购物车列表
     */
    lists(config = {}) {
      return request({
        url: "/v1/shop_cart/lists",
        methods: "get",
        ...config,
      });
    },
    /**
     * 添加购物车
     */
    add(config = {}) {
      return request({
        url: "/v1/shop_cart/add",
        methods: "post",
        ...config,
      });
    },
    /**
     * 修改数量
     */
    countChange(config = {}) {
      return request({
        url: "/v1/shop_cart/count_change",
        methods: "post",
        ...config,
      });
    },
    /**
     * 删除购物车
     */
    del(config = {}) {
      return request({
        url: "/v1/shop_cart/del",
        methods: "post",
        ...config,
      });
    },
  },

  /**
   * 报刊
   *
   * 1.result.count
   * 只在page==1 && is_total_count== 1时返回。其余返回0
   *
   * 2.is_shop_cart_count
   * 只在需要时传 1（例如h5中不需要就传2，还有就是进入报刊列表页之后，只是改变了筛选条件，翻页时，传2，当用户选中商品加入了购物车，再重新获取传1）
   * 3. is_total_count说明：
   * 在pc中因为分页需要，传1
   * 在h5中不用这个做分页，判断如果返回的length < 10 则没有更多数据
   */
  book: {
    /**
     * 列表
     */
    lists(config = {}) {
      return request({
        url: "/v1/book/lists",
        methods: "get",
        ...config,
      });
    },

    /**
     * 详情
     */
    detail(config = {}) {
      return request({
        url: "/v1/book/detail",
        methods: "get",
        ...config,
      });
    },
  },

  /**
   * 订单
   */
  order: {
    /**
     * 列表
     */
    lists(config = {}) {
      return request({
        url: "/v1/order/lists",
        methods: "get",
        ...config,
      });
    },

    /**
     * 详情
     */
    detail(config = {}) {
      return request({
        url: "/v1/order/detail",
        methods: "get",
        ...config,
      });
    },

    /**
     * 生成订单
     */
    add(config = {}) {
      return request({
        url: "/v1/order/add",
        methods: "post",
        ...config,
      });
    },

    /**
     * 取消订单
     */
    cancel(config = {}) {
      return request({
        url: "/v1/order/cancel",
        methods: "post",
        ...config,
      });
    },

    // 支付相关部分最后处理
  },

  /**
   * 发票
   */
  invoice: {
    /**
     * 发票列表
     */
    lists(config = {}) {
      return request({
        url: "/v1/invoice/lists",
        methods: "get",
        ...config,
      });
    },

    /**
     * 申请开票
     */
    add(config = {}) {
      return request({
        url: "/v1/invoice/add",
        methods: "post",
        ...config,
      });
    },

    /**
     * 可开票报刊列表
     */
    books(config = {}) {
      return request({
        url: "/v1/invoice/invoice_books",
        methods: "get",
        ...config,
      });
    },

    /**
     * 重开发票
     */
    reopen(config = {}) {
      return request({
        url: "/v1/invoice/reopen",
        methods: "post",
        ...config,
      });
    },

    /**
     * 重发邮箱
     */
    email(config = {}) {
      return request({
        url: "/v1/invoice/resend_email",
        methods: "post",
        ...config,
      });
    },

    /**
     * 根据公司名称查询税号
     */
    company(config = {}) {
      return request({
        url: "/v1/invoice/get_company",
        methods: "get",
        ...config,
      });
    },
  },
};
